import type { SavedSearch } from './queries/types';

const savedSearchDefault: SavedSearch = {
  __typename: 'ApacSavedSearch',
  id: 'faddf0cc-18e1-11eb-805f-f79944aec550',
  name: 'All Australia',
  countryCode: 'au',
  countLabel: '2',
  createdDate: {
    __typename: 'SeekDateTime',
    shortAbsoluteLabel: '15 Aug 2022',
  },
  subscribeToNewJobs: true,
  query: {
    __typename: 'SavedSearchApacQuery',
    searchQueryString:
      'where=All%20Australia&worktype=242&daterange=7&salarytype=annually&salaryrange=40000-70000',
    parameters: [
      {
        __typename: 'SavedSearchParameters',
        type: 'locationId',
        value: ['Melbourne'],
      },
      {
        __typename: 'SavedSearchParameters',
        type: 'filter.category',
        value: [
          'Banking & Financial Services',
          'Administration & Office Support',
        ],
      },
      {
        __typename: 'SavedSearchParameters',
        type: 'salary',
        value: ['$3K to $30K+ Monthly'],
      },
      {
        __typename: 'SavedSearchParameters',
        type: 'filter.workType',
        value: ['Part time'],
      },
    ],
  },
};

const baristaSS: SavedSearch = {
  ...savedSearchDefault,
  id: 'b49d2a48-a673-11e8-9493-53c77851501c',
  name: 'Barista in Hospitality & Tourism',
  countLabel: '0',
  subscribeToNewJobs: false,
};

export const apacSavedSearches: SavedSearch[] = [savedSearchDefault, baristaSS];
